<template>
  <div
      class="fixed inset-0 flex items-center justify-center border-b-md z-50"
  >
    <div class="bg-white rounded-lg shadow-lg w-96 p-6">
      <h2 class="text-lg font-medium mb-4">Select Color</h2>
      <div class="p-4">
        <!-- Vuetify Color Picker -->
        <v-color-picker
            v-model="currentColor"
            :swatches="params.colors"
            :show-swatches="params.colors !== undefined"
            hide-sliders
            hide-inputs
            class="mb-6"
        ></v-color-picker>

        <!-- Action Buttons -->
        <div class="flex justify-end space-x-4">
          <v-btn outlined @click="cancel">Cancel</v-btn>
          <v-btn color="primary" @click="save">Save</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {VColorPicker} from 'vuetify/components';

export default {
  name: "ColorSelector",
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  components: {
    VColorPicker,
  },
  data() {
    return {
      initialColor: '#000000', // The initial color
      currentColor: '#000000', // The selected color
    };
  },
  created() {
    // Set the initial color
    this.currentColor = this.params.value;
    this.initialColor = this.params.value;
  },
  methods: {
    getValue() {
      // Return the selected color
      return this.currentColor;
    },
    isPopup() {
      // Indicate this is a popup editor
      return true;
    },
    save() {
      // Confirm the selected color
      this.params.stopEditing();
    },
    cancel() {
      // Revert to the initial color and stop editing
      this.currentColor = this.initialColor;
      this.params.stopEditing();
    },
  },
};
</script>

<style scoped>
/* Styling adjustments for better layout */
</style>
